<template>
  <div>
    <step-intro iframe-url="">
        <p>
        Thank you for providing the information we need to create your PDF layout. Once you submit it, we’ll send you a proof as soon as possible. If we have any questions, we’ll get in touch.
        </p>
    </step-intro>
    <validation-observer tag="div" :step-index="stepIndex">
        <box title="Contact Details">
            <div class="columns is-multiline">
                <div class="column">
                    <validation-provider rules="required" v-slot="{ errors }">
                        <b-field label="First name" :type="{ 'is-danger': errors[0]}" :message="errors">
                            <b-input v-model="contact.firstName"></b-input>
                        </b-field>
                    </validation-provider>
                </div>
                <div class="column">
                    <validation-provider rules="required" v-slot="{ errors }">
                        <b-field label="Last name" :type="{ 'is-danger': errors[0]}" :message="errors">
                            <b-input v-model="contact.lastName"></b-input>
                        </b-field>
                    </validation-provider>
                </div>
                <div class="column">
                    <validation-provider rules="required|email" v-slot="{ errors }">
                        <b-field label="Email address" :type="{ 'is-danger': errors[0]}" :message="errors">
                            <b-input v-model="contact.email" type="email"></b-input>
                        </b-field>
                    </validation-provider>
                </div>
                <div class="column is-full">
                    <b-field label="Additional Remarks">
                        <b-input type="textarea" v-model="contact.remarks"></b-input>
                    </b-field>
                </div>
            </div>
            <validation-provider :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
                <b-field class="field--small" :type="{ 'is-danger': errors[0]}" :message="errors">
                    <b-checkbox v-model="AgreeWithPrivacy"> I agree to the <a href="https://www.persoonlijkproefschrift.nl/download/private/Voorwaarden-Persoonlijk-Proefschrift.pdf" target="_blank">privacy policy</a>.</b-checkbox>
                </b-field>
            </validation-provider>
        </box>
    </validation-observer>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import box from './../components/box.vue';
import stepIntro from './../components/step-intro.vue';
import ValidationObserver from './../components/validation-observer.vue';

export default {
    props: ['stepIndex'],
    components: {
        box,
        stepIntro,
        ValidationObserver
    },
    computed: {
        ...mapFields(['contact']),
    },
    data() {
        return {
            AgreeWithPrivacy: false,
        }
    }
}
</script>